module.exports = __webpack_public_path__ + "static/media/user_profile_registered.25160378.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user_profile_registered.svg
// module id = 1771
// module chunks = 0